"use client";
import type { ShoppingCart } from "@/backend/services/shopping-cart/types";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { api } from "@/trpc/react";
import { Fragment } from "react";

export const ShoppingCartCookieListener = ({
  cartId,
  initial,
}: {
  cartId?: string;
  initial: { id: string; hi: boolean; hm: boolean };
}) => {
  const { data } = api.shoppingCart.getCart.useQuery(undefined, {
    suspense: true,
    initialData: initial,
  });

  const hasItems = !!data?.hi;
  const hasManyItems = !!data?.hm;

  return (
    <Button
      variant="subtle"
      className={cn("relative w-full self-center", hasItems ? "" : "")}
      aria-label="Warenkorb"
    >
      <div className="relative h-5 w-5">
        {hasItems && (
          <div className="absolute -right-2 -top-0.5 flex h-2 w-2 animate-pulse items-center justify-center rounded-full bg-orange-500 text-white" />
        )}
        {hasItems && (
          <div className="absolute -right-2 -top-0.5 flex h-2 w-2 animate-ping items-center justify-center rounded-full bg-orange-500 text-white" />
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-full w-full"
        >
          {hasItems && (
            <Fragment>
              <defs>
                {/* Define wave path and motion path */}
                <path
                  id="wavepath"
                  d="M 0 48 0 12 Q 3.6 11.016 7.2 12 t 7.2 0 7.2 0 7.2 0 7.2 0 7.2 0 v24 z"
                  strokeWidth={0}
                />
                <path id="motionpath" d="M -14.4 0 0 0" />

                {/* Clip path using the cart shape */}
                <clipPath id="cartClip">
                  <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
                </clipPath>
              </defs>

              {/* The wave inside the cart, clipped */}
              <g clipPath="url(#cartClip)">
                <use
                  href="#wavepath"
                  y={hasManyItems ? "-0.7" : "0.5"}
                  fill="rgb(249,115,22)"
                >
                  <animateMotion dur="1s" repeatCount="indefinite">
                    <mpath href="#motionpath" />
                  </animateMotion>
                </use>
              </g>
            </Fragment>
          )}

          {/* Shopping cart icon */}
          <circle cx="8" cy="21" r="1" />
          <circle cx="19" cy="21" r="1" />
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
        </svg>
      </div>
    </Button>
  );
};
